import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styles from './CustomLink.module.scss';
type Props = {
  to: string;
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'unstyled';
  shouldScrollToTop?:boolean
};
const CustomLink: FC<Props> = ({ to, children, className, variant = 'default',shouldScrollToTop = false }) => {
  const linkClass = variant === 'unstyled' ? '' : styles.link;
  const scrollToTop = () => {
    if (shouldScrollToTop) {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 0);
    }
  };
  return (
    <Link to={to} className={`${linkClass} ${className || ''}`} onClick={scrollToTop}>
      {children}
    </Link>
  );
};

export default CustomLink;
